import React from "react"
import smClient from "../helpers/smApolloClient"
import cartClient from "../helpers/cartApolloClient"
import checkoutClient from "../helpers/checkoutApolloClient"
import seeAllClient from "../helpers/seeAllClient"
import userActionsClient from "../helpers/userActionsClient"
import profileClient from "../helpers/profileClient"
import estoreClient from "../helpers/estoreClient"
import b2bClient from "../helpers/b2bClient"
import { ApolloProvider } from "@apollo/react-hooks"
import { redirectOnTokenExpiration } from "../utils/utils"

const withApolloClient = (ComponentToWrap, props) => {
  // console.log('withApolloClient::', props, ComponentToWrap)
  redirectOnTokenExpiration()
  return componentProps => {
    // console.log(componentProps)
    let client = smClient
    switch (props.client) {
      case "smClient": //AKA homepageClient
        client = smClient
        break
      case "cartClient":
        client = cartClient
        break
      case "checkoutClient":
        client = checkoutClient
        break
      case "seeAllClient":
        client = seeAllClient
        break
      case "userActionsClient":
        client = userActionsClient
        break
      case "profileClient":
        client = profileClient
        break
      case "estoreClient":
        client = estoreClient
        break
      case "b2bClient":
        client = b2bClient
        break
      default:
        client = smClient
    }
    return (
      <ApolloProvider client={client}>
        <ComponentToWrap {...props} {...componentProps} />
      </ApolloProvider>
    )
  }
}

export default withApolloClient
